import React from 'react';
import { Phone, CheckCircle, Wrench, Truck, Settings, Droplet, Gauge } from 'lucide-react';
export function IsuzuRepairPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-6465">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-6466">
        <div className="container mx-auto px-4" data-id="element-6467">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-6468">
            Isuzu Truck Repair and Maintenance
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-6469">
            Complete Isuzu Truck System Maintenance and Repair Services
          </p>
          <p className="text-lg text-gray-200 text-center mt-2" data-id="element-6470">
            Including maintenance, inspection, diagnostics, and repair
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-6471">
        <div className="max-w-4xl mx-auto" data-id="element-6472">
          {/* Introduction */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6473">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-6474">
              Garrett Auto and Truck Service: Isuzu Commercial Truck Specialists
            </h2>

            <p className="text-lg text-gray-700 mb-4" data-id="element-6475">
              <strong data-id="element-6476">
                Experience the Best in Isuzu Truck Maintenance and Repair
              </strong>
            </p>

            <p className="text-gray-700" data-id="element-6477">
              Welcome to Garrett Auto and Truck Service, where we offer expert
              care for your Isuzu commercial trucks. Our team specializes in
              providing top-notch service for each Isuzu model, ensuring they
              run efficiently and reliably.
            </p>
          </div>

          {/* Isuzu N-Series */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6478">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-6479">
              Isuzu N-Series: Versatility Meets Reliability
            </h2>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-6480">
              Benefits of the N-Series
            </h3>
            <div className="grid md:grid-cols-3 gap-4 mb-6" data-id="element-6481">
              <div className="bg-blue-50 rounded-lg p-4" data-id="element-6482">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-6483">Compact Design</h4>
                <p className="text-gray-700 text-sm" data-id="element-6484">
                  Ideal for city and urban environments
                </p>
              </div>
              <div className="bg-blue-50 rounded-lg p-4" data-id="element-6485">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-6486">
                  Fuel Efficiency
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6487">
                  Excellent for optimizing operation costs
                </p>
              </div>
              <div className="bg-blue-50 rounded-lg p-4" data-id="element-6488">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-6489">
                  Maneuverability
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6490">
                  Easy to navigate in tight spaces
                </p>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-6491">
              Maintenance and Repair for the N-Series
            </h3>
            <div className="space-y-3" data-id="element-6492">
              <div className="flex items-start" data-id="element-6493">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6494" />
                <div data-id="element-6495">
                  <strong className="text-gray-900" data-id="element-6496">Engine Care:</strong>
                  <span className="text-gray-700" data-id="element-6497">
                    {' '}
                    Regular oil changes and fuel system checks for both gasoline
                    and diesel models
                  </span>
                </div>
              </div>
              <div className="flex items-start" data-id="element-6498">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6499" />
                <div data-id="element-6500">
                  <strong className="text-gray-900" data-id="element-6501">Brake Service:</strong>
                  <span className="text-gray-700" data-id="element-6502">
                    {' '}
                    Frequent inspections and maintenance due to urban usage
                  </span>
                </div>
              </div>
              <div className="flex items-start" data-id="element-6503">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6504" />
                <div data-id="element-6505">
                  <strong className="text-gray-900" data-id="element-6506">Electrical System:</strong>
                  <span className="text-gray-700" data-id="element-6507">
                    {' '}
                    Regular check-ups for intricate electrical systems
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Isuzu F-Series */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6508">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-6509">
              Isuzu F-Series: Power and Performance for Heavier Loads
            </h2>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-6510">
              Benefits of the F-Series
            </h3>
            <div className="grid md:grid-cols-3 gap-4 mb-6" data-id="element-6511">
              <div className="bg-green-50 rounded-lg p-4" data-id="element-6512">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-6513">
                  Powerful Engines
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6514">
                  Designed for heavy-duty tasks
                </p>
              </div>
              <div className="bg-green-50 rounded-lg p-4" data-id="element-6515">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-6516">
                  Spacious Cabins
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6517">
                  Comfortable for long hauls
                </p>
              </div>
              <div className="bg-green-50 rounded-lg p-4" data-id="element-6518">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-6519">Durability</h4>
                <p className="text-gray-700 text-sm" data-id="element-6520">
                  Built to withstand rigorous use
                </p>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-6521">
              Maintenance and Repair for the F-Series
            </h3>
            <div className="space-y-3" data-id="element-6522">
              <div className="flex items-start" data-id="element-6523">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6524" />
                <div data-id="element-6525">
                  <strong className="text-gray-900" data-id="element-6526">
                    Diesel Engine Maintenance:
                  </strong>
                  <span className="text-gray-700" data-id="element-6527">
                    {' '}
                    Special focus on turbochargers and cooling systems
                  </span>
                </div>
              </div>
              <div className="flex items-start" data-id="element-6528">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6529" />
                <div data-id="element-6530">
                  <strong className="text-gray-900" data-id="element-6531">Transmission Care:</strong>
                  <span className="text-gray-700" data-id="element-6532">
                    {' '}
                    Regular checks and servicing for both manual and automatic
                    models
                  </span>
                </div>
              </div>
              <div className="flex items-start" data-id="element-6533">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6534" />
                <div data-id="element-6535">
                  <strong className="text-gray-900" data-id="element-6536">
                    Suspension and Steering:
                  </strong>
                  <span className="text-gray-700" data-id="element-6537">
                    {' '}
                    More frequent inspections recommended due to heavier loads
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Isuzu NPR */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6538">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-6539">
              Isuzu NPR: The All-Rounder for Diverse Needs
            </h2>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-6540">
              Benefits of the NPR
            </h3>
            <div className="grid md:grid-cols-3 gap-4 mb-6" data-id="element-6541">
              <div className="bg-purple-50 rounded-lg p-4" data-id="element-6542">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-6543">Flexibility</h4>
                <p className="text-gray-700 text-sm" data-id="element-6544">
                  Suits a wide range of industries
                </p>
              </div>
              <div className="bg-purple-50 rounded-lg p-4" data-id="element-6545">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-6546">
                  Economical Operation
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6547">
                  Good fuel economy and low maintenance costs
                </p>
              </div>
              <div className="bg-purple-50 rounded-lg p-4" data-id="element-6548">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-6549">Driver Comfort</h4>
                <p className="text-gray-700 text-sm" data-id="element-6550">
                  Ergonomically designed for ease of use
                </p>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-6551">
              Maintenance and Repair for the NPR
            </h3>
            <div className="space-y-3" data-id="element-6552">
              <div className="flex items-start" data-id="element-6553">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6554" />
                <div data-id="element-6555">
                  <strong className="text-gray-900" data-id="element-6556">
                    Routine Maintenance:
                  </strong>
                  <span className="text-gray-700" data-id="element-6557">
                    {' '}
                    Importance of adhering to service schedules for long-term
                    reliability
                  </span>
                </div>
              </div>
              <div className="flex items-start" data-id="element-6558">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6559" />
                <div data-id="element-6560">
                  <strong className="text-gray-900" data-id="element-6561">
                    Brake and Tire Service:
                  </strong>
                  <span className="text-gray-700" data-id="element-6562">
                    {' '}
                    Essential for safety and efficiency
                  </span>
                </div>
              </div>
              <div className="flex items-start" data-id="element-6563">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6564" />
                <div data-id="element-6565">
                  <strong className="text-gray-900" data-id="element-6566">Cooling System:</strong>
                  <span className="text-gray-700" data-id="element-6567">
                    {' '}
                    Regular checks to prevent overheating, especially under
                    heavy use
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Our Services */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6568">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-6569">
              Garrett Auto and Truck Service: Your Isuzu Maintenance Experts
            </h2>

            <p className="text-gray-700 mb-6" data-id="element-6570">
              At Garrett Auto and Truck Service, we understand the unique needs
              of each Isuzu model. Our team is equipped with the knowledge and
              tools to provide the best maintenance and repair services,
              ensuring your Isuzu truck remains a reliable asset for your
              business.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-6571">
              <div className="text-center" data-id="element-6572">
                <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6573">
                  <Settings className="text-blue-600" size={32} data-id="element-6574" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-6575">
                  Tailored Services
                </h3>
                <p className="text-gray-700 text-sm" data-id="element-6576">
                  Custom maintenance plans for each Isuzu model
                </p>
              </div>

              <div className="text-center" data-id="element-6577">
                <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6578">
                  <Wrench className="text-green-600" size={32} data-id="element-6579" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-6580">
                  Quality Parts
                </h3>
                <p className="text-gray-700 text-sm" data-id="element-6581">
                  Genuine Isuzu parts and state-of-the-art diagnostic tools
                </p>
              </div>

              <div className="text-center" data-id="element-6582">
                <div className="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6583">
                  <CheckCircle className="text-purple-600" size={32} data-id="element-6584" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-6585">
                  Professional Team
                </h3>
                <p className="text-gray-700 text-sm" data-id="element-6586">
                  Trained in latest Isuzu truck care techniques
                </p>
              </div>
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-6587">
              Comprehensive Maintenance Services
            </h3>
            <div className="grid md:grid-cols-2 gap-3" data-id="element-6588">
              <div className="flex items-start" data-id="element-6589">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6590" />
                <span className="text-gray-700" data-id="element-6591">
                  Engine oil and filter changes
                </span>
              </div>
              <div className="flex items-start" data-id="element-6592">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6593" />
                <span className="text-gray-700" data-id="element-6594">
                  Fluid top-offs and monitoring
                </span>
              </div>
              <div className="flex items-start" data-id="element-6595">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6596" />
                <span className="text-gray-700" data-id="element-6597">
                  Brake inspections and service
                </span>
              </div>
              <div className="flex items-start" data-id="element-6598">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6599" />
                <span className="text-gray-700" data-id="element-6600">
                  Advanced diagnostic services
                </span>
              </div>
              <div className="flex items-start" data-id="element-6601">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6602" />
                <span className="text-gray-700" data-id="element-6603">
                  Tire maintenance and rotation
                </span>
              </div>
              <div className="flex items-start" data-id="element-6604">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6605" />
                <span className="text-gray-700" data-id="element-6606">
                  Cooling system maintenance
                </span>
              </div>
            </div>
          </div>

          {/* Industries Served */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6607">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-6608">
              Industries We Serve
            </h2>

            <p className="text-gray-700 mb-6" data-id="element-6609">
              Isuzu commercial trucks serve various industries, and each
              industry has specific needs that Isuzu trucks cater to:
            </p>

            <div className="grid md:grid-cols-2 gap-4" data-id="element-6610">
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6611">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6612">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6613" />
                  Landscaping
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6614">
                  Retaining walls, deck construction, tree service, lawn care
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6615">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6616">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6617" />
                  Delivery Services
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6618">
                  Furniture, groceries, appliances, general freight, food
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6619">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6620">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6621" />
                  HVAC & Plumbing
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6622">
                  Heating, cooling, plumbing services with extra storage
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6623">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6624">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6625" />
                  Vending Services
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6626">
                  Powerful hauling for vending machine businesses
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6627">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6628">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6629" />
                  Junk Removal
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6630">
                  Residential and commercial with dump features
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6631">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6632">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6633" />
                  Moving Companies
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6634">
                  Excellent fuel economy and customizable cabs
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6635">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6636">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6637" />
                  Electricians
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6638">
                  Reliable performance with ample cargo space
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6639">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6640">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6641" />
                  Construction
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6642">
                  Durability and hauling for construction needs
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6643">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6644">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6645" />
                  Agriculture
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6646">
                  Powerful engine with customizable bed options
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6647">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6648">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6649" />
                  Rental Companies
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6650">
                  Maintenance-free ignition and long-life timing chain
                </p>
              </div>
            </div>
          </div>

          {/* Common Repairs */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6651">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-6652">
              Common Repairs and Maintenance
            </h2>

            <div className="space-y-6" data-id="element-6653">
              <div className="border-l-4 border-[#B1050B] pl-6" data-id="element-6654">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-6655">
                  <Wrench className="mr-2 text-[#B1050B]" size={24} data-id="element-6656" />
                  Engine Maintenance
                </h3>
                <p className="text-gray-700" data-id="element-6657">
                  Regular cleaning of the engine is crucial, especially in
                  diesel engines, to prevent performance reduction and extend
                  road life.
                </p>
              </div>

              <div className="border-l-4 border-blue-500 pl-6" data-id="element-6658">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-6659">
                  <Droplet className="mr-2 text-blue-600" size={24} data-id="element-6660" />
                  Oil and Filter Changes
                </h3>
                <p className="text-gray-700" data-id="element-6661">
                  Regular oil and filter changes are essential to prevent engine
                  oil contamination from dirt, dust, and debris, ensuring
                  optimal engine performance.
                </p>
              </div>

              <div className="border-l-4 border-green-500 pl-6" data-id="element-6662">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-6663">
                  <Settings className="mr-2 text-green-600" size={24} data-id="element-6664" />
                  Fluid Monitoring
                </h3>
                <p className="text-gray-700" data-id="element-6665">
                  Keeping an eye on and regularly replacing/changing engine
                  coolant, brake fluid, power steering fluids, and windshield
                  washer fluid is vital for performance and safety.
                </p>
              </div>

              <div className="border-l-4 border-purple-500 pl-6" data-id="element-6666">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-6667">
                  <Gauge className="mr-2 text-purple-600" size={24} data-id="element-6668" />
                  Tire Maintenance
                </h3>
                <p className="text-gray-700" data-id="element-6669">
                  Regular inspection of tire pressure and tread depth is
                  important for safe driving and fuel efficiency. Tires should
                  be changed when tread depth becomes insufficient, and rotated
                  regularly for even wear.
                </p>
              </div>
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 mt-6" data-id="element-6670">
              <p className="text-gray-800" data-id="element-6671">
                <strong data-id="element-6672">Important:</strong> These maintenance and repair
                practices are crucial for ensuring the longevity and efficiency
                of Isuzu commercial trucks across various industries.
              </p>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-6673">
            <h2 className="text-3xl font-bold mb-4" data-id="element-6674">
              Schedule Your Isuzu Service Today
            </h2>
            <p className="text-xl mb-6" data-id="element-6675">
              Expert Repair and Maintenance for Your Isuzu Commercial Trucks
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-6676">
              <Phone className="mr-3" size={24} data-id="element-6677" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-6678">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
            <p className="mt-2 text-gray-400" data-id="element-6679">
              Trust Garrett Auto and Truck Service - Your Partner in Keeping
              Isuzu Trucks on the Road
            </p>
          </div>
        </div>
      </div>
    </div>;
}